import { HttpsCallableFactory } from "./functions"

import type { Jobseeker } from "interfaces/IJobseeker"
import type { PostRecruitPayload } from "interfaces/RecruitIF"
import type { Recruit } from "interfaces/RecruitIF"

const hcf = new HttpsCallableFactory("recruit")

export const getAllRecruitDetails = hcf.callFunction<void, Recruit[]>(
  "getAllDetailsForCompany",
)

export const switchRecuitIsPublished = hcf.callFunction<string, void>(
  "switchIsPublished",
)

export const deleteRecuitDetail = hcf.callFunction<string, void>("deleteDetail")

export const getBrowsingHistories = hcf.callFunction<void, Jobseeker[]>(
  "browsingHistories",
)

export const postRecruit = hcf.callFunction<PostRecruitPayload, Recruit>(
  "postRecruit",
)
